import { render } from "./credit-notes-overdue.vue?vue&type=template&id=5dcc55ce"
import script from "./credit-notes-overdue.vue?vue&type=script&lang=js"
export * from "./credit-notes-overdue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__